import { useMutation, useQueryClient } from '@tanstack/react-query';
import { refreshSession } from '@/api/auth.api';
import { setAccessToken } from '@/lib/auth/session';

/**
 * Re-issues the session after a server-side role change (e.g. becoming a
 * Startup Admin once a startup is created, MYN-46). Persists the new token and
 * updates the auth cache so nav/landing recompute without a full reload.
 */
export function useRefreshSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refreshSession,
    onSuccess: ({ accessToken, user }) => {
      setAccessToken(accessToken);
      queryClient.setQueryData(['auth', 'me'], user);
    },
  });
}
